<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.kelengkapanPelamar }}</strong>
          </p>
        </template>
        <!-- <CRow>
          <CCol cols="12" md="12" lg="12">
            <b-button variant="primary" class="mb-4" v-b-modal.modal-input>
              <CIcon name="cil-plus" />
              {{ $store.state.table.tambahModal }}
            </b-button>
          </CCol>
        </CRow> -->
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #Actions="{ item }">
                <div class="flex">
                  <CButton variant="warning" class="mr-1 btn-warning" v-c-tooltip.hover.click="'Edit Kelengkapan Pelamar'" v-b-modal.modal-edit @click="(data = item), (edit = !edit)">
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton
                    v-if="item.statusKelengkapan == 1"
                    variant="info"
                    class="mr-1 btn-info"
                    v-c-tooltip.hover.click="'Detail Pelamar'"
                    v-b-modal.modal-detail
                    @click="(data = item), (detail = !detail)"
                  >
                    <CIcon name="cil-info" />
                  </CButton>
                </div>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-edit :data="data" :loker="loker" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-detail :data="data" :detail="detail" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalEdit from "./modalEdit/modalEdit.vue";
import modalDetail from "./modalDetail/modalDetail.vue";

export default {
  components: {
    modalEdit,
    modalDetail,
  },
  name: "kelengkapanPelamar",
  data() {
    return {
      detail: false,
      edit: false,
      data: {},
      loker: [],
      items: [],

      filter: {},
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaPengirim",
          label: this.$store.state.table.namaPengirim,
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "alamatPengirim",
          label: this.$store.state.table.alamatPengirim,
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "emailPengirim",
          label: this.$store.state.table.emailPengirim,
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaLoker",
          label: this.$store.state.table.namaLoker,
          _style: "width: 13%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaPosisi",
          label: this.$store.state.table.namaPosisi,
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "token",
          label: this.$store.state.table.token,
          _style: "width: 5%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          class: "table-option-4 text-center",
          filter: false,
          sorter: false,
        },
      ];
    },
  },
  mounted() {
    this.getDatas();
    this.getLoker();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPelamar = await vm.$axios.post("/postLoker/listByStatusPerHalaman", {
        ...vm.filter,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
        statusPostLoker: 1,
      });
      // console.log("listPelamar", listPelamar);
      vm.items =
        listPelamar.data.status == 200
          ? listPelamar.data.data.map((x, idx) => {
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                posisiDilamar: `${x.namaLoker} - (Posisi : ${x.namaPosisi})`,
              };
            })
          : [];
      vm.totalRows = Number(listPelamar.data.count);
      vm.loading = false;
    },
    async getLoker() {
      let vm = this;
      let listLoker = await vm.$axios.post("/loker/list");
      vm.loker =
        listLoker.data.status == 200
          ? listLoker.data.data.map((x) => {
              return {
                ...x,
                posisiDilamar: `${x.namaLoker} - (Posisi : ${x.namaPosisi})`,
              };
            })
          : [];
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
